import * as React from "react";
import {Modal, ModalBody, ModalHeader, ModalFooter} from "reactstrap";
import {INTERACTION_PROCESS_MTA, INTERACTION_PROCESS_RENEWAL} from "@ferry/journey-services";
import {resourcesHelper} from "@ferry/portal-core";

interface IProps {
    title: React.ReactNode;
    explanationWording: React.ReactNode;
    anythingElseTitle?: React.ReactNode;
    explanationAnythingElseWording?: React.ReactNode;
    onClose?: () => void;
    passFontAndLineStyles?: string;
    passMarginTopStyle?: string;
    explanationWordingStyles?: string;
}

interface IState {
    isOpen: boolean;
}

export class StorageSuccessModal extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            isOpen: true
        };
        this.close = this.close.bind(this);
    }

    public render() {
        const closeBtn = <button className="btn-close" onClick={this.close}/>
        let anythingElseStyle;
        let paddingBottomStyle;
        if (this.props.passFontAndLineStyles) {
            anythingElseStyle = this.props.passFontAndLineStyles?.length > 0 ? "anything-else-renewal" : "anything-else";
            paddingBottomStyle = this.props.passFontAndLineStyles?.length > 0 ? "pb-0" : "";
        }

        return (
            <Modal className={`success-modal ${this.props.passMarginTopStyle}`} isOpen={this.state.isOpen}>
                <ModalHeader className={`${paddingBottomStyle}`} close={closeBtn}>
                    <div className="d-flex success-icon-container">
                        <img className="success-icon d-block"
                             src={`/${resourcesHelper.THEME_PATH}/img/check-mark-green-light.svg`}
                             alt="Payment complete"
                             aria-label="Payment complete picture"
                             tabIndex={0}
                        />
                        <span id="success-modal-title" className="success-title"><p>{this.props.title}</p></span>
                    </div>
                </ModalHeader>
                <ModalBody className="pt-0">
                    <div className={`${this.props.explanationWordingStyles
                    && this.props.explanationWordingStyles.length > 0 ? this.props.explanationWordingStyles : ""}`}>
                        {this.props.explanationWording}
                    </div>
                    <div className={`${this.props.passFontAndLineStyles}`}>
                        {this.props.anythingElseTitle &&
                            <span id="success-modal-title-anything-else" className={`success-title font-weight-bold ${anythingElseStyle}`}>
                                {this.props.anythingElseTitle}
                            </span>
                        }
                        {this.props.explanationAnythingElseWording &&
                            <div>
                                <p>{this.props.explanationAnythingElseWording}</p>
                            </div>
                        }
                    </div>
                </ModalBody>
                <div className="empty-column"/>
                <ModalFooter>
                    <button type="button" className="btn btn-blue-dashboard m-0" onClick={this.close}>Ok, I understand</button>
                </ModalFooter>
            </Modal>
        )
    }

    private close(): void {
        window.sessionStorage.removeItem("showPopup");
        window.sessionStorage.removeItem("mtaSuccessMessageText");

        const referrerJourney: string | null = window.sessionStorage.getItem("referrerJourney");
        const mtaSuccessPopupMessage: string | null = window.sessionStorage.getItem("mtaSuccessMessageText");

        if (referrerJourney) {
            if (referrerJourney === INTERACTION_PROCESS_MTA && mtaSuccessPopupMessage) {
                window.sessionStorage.removeItem("mtaSuccessMessageText");
            } else if (referrerJourney === "missedPayment" || referrerJourney === "wolfMissedPayment") {
                window.sessionStorage.removeItem("paymentAmount");
            }
            else if (referrerJourney === INTERACTION_PROCESS_RENEWAL) {
                window.sessionStorage.removeItem("referrerJourney");
            }
        }

        this.setState({
            isOpen: false
        });

        if (this.props.onClose) {
            this.props.onClose();
        }
    }
}
